import { Core4Age } from '../../../model/Entities';

export const baseballCore4Age910: Core4Age = {
    code: '9-10',
    minAge: 8,
    maxAge: 10,
};

export const baseballCore4Age1112: Core4Age = {
    code: '11-12',
    minAge: 11,
    maxAge: 12,
};

export const baseballCore4Age1314: Core4Age = {
    code: '13-14',
    minAge: 13,
    maxAge: 14,
};

export const baseballCore4Age1516: Core4Age = {
    code: '15-16',
    minAge: 15,
    maxAge: 16,
};

export const baseballCore4Age1718: Core4Age = {
    code: '17-18',
    minAge: 17,
    maxAge: 18,
};

export const baseballCore4AgeCollege: Core4Age = {
    code: 'COLLEGE',
    minAge: 19,
    maxAge: 24,
};

export const baseballCore4AgePro: Core4Age = {
    code: 'PRO',
    minAge: 25,
    maxAge: 99,
};
